var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loaded)?_c('img',{staticClass:"loaded-image",attrs:{"src":_vm.src,"alt":"Loaded Image"}}):_c('div',{staticClass:"image-placeholder"},[_c('div',{staticClass:"loader-mini"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }